import { ApplicationQuestion } from './application-question';
import { ApplicationField } from './application-field';
import { UTCDate } from '../utc-date';
import { AttributeDefinition } from '../attributes/attributeDefinition';
import { FormPage } from '../application/formPage';

export class ApplicationDefinition {
  public id: string;
  public title: string;
  public introduction: string;
  public confirmation: string;
  public publicLinkInstructions: string;
  public newMemberDefaultStatus: string;
  public deadline: Date;
  public hasExpired: boolean;
  public requestUri: string;
  private _questions: ApplicationQuestion[] = [];
  public fields: ApplicationField[];
  public canDelete: boolean;
  public static DEFAULT_DEADLINE_DAYS: number = 14;
  public formType: string;
  public pages: FormPage[];
  public validateAddress: boolean;
  public isAddressSharedLabel: string;
  public includePaymentPage: boolean;
  public isArchived: boolean;

  constructor() {}

  public get hasDeadline() {
    return !!this.deadline;
  }

  public get questions(): ApplicationQuestion[] {
    return this._questions;
  }
  public closeApplication() {
    this.deadline = UTCDate.getDate(-1);
  }

  public setDeadlineToDefault() {
    this.deadline = UTCDate.getDate(ApplicationDefinition.DEFAULT_DEADLINE_DAYS);
  }

  private setQuestions(value: ApplicationQuestion[]) {
    this._questions = value.map((question) => {
      if (question) {
        return ApplicationQuestion.parse(question);
      }
    });
    this.pages?.forEach((page) => {
      page.questions = this._questions.filter((q) => q.formPageId == page.id);
    });
  }

  private updateQuestions(updatedQuestions: ApplicationQuestion[]) {
    //updates the existing questions
    updatedQuestions.forEach((q) => {
      let index = this._questions.findIndex(
        (x) => x.attributeDefinition.id == q.attributeDefinition.id
      );
      if (index != -1) {
        this._questions[index].attributeDefinition = AttributeDefinition.parse(
          q.attributeDefinition
        );
        this._questions[index].conditions = q.conditions;
        this._questions[index].descriptionOverride = q.descriptionOverride;
        this._questions[index].isRequired = q.isRequired;
        this._questions[index].isReadOnly = q.isReadOnly;
        this._questions[index].isHidden = q.isHidden;
        this._questions[index].showCurrentValue = q.showCurrentValue;
        this._questions[index].formPageId = q.formPageId;
      } else {
        //adds a new questions
        this._questions.push(ApplicationQuestion.parse(q));
      }
    });

    //removes  questions
    this._questions.forEach((q) => {
      let index = updatedQuestions.findIndex(
        (x) => x.attributeDefinition.id == q.attributeDefinition.id
      );
      if (index == -1) {
        this._questions.splice(this._questions.indexOf(q), 1);
      }

      this.pages?.forEach((page) => {
        page.questions = this._questions.filter((q) => q.formPageId == page.id);
      });
    });
  }
  private setData(data: any) {
    this.formType = data.formType;
    this.id = data.id;
    this.title = data.title;
    this.introduction = data.introduction;
    this.publicLinkInstructions = data.publicLinkInstructions;
    if (!data.confirmation) {
      this.confirmation = 'Thanks for completing the application!';
    } else {
      this.confirmation = data.confirmation;
    }
    this.newMemberDefaultStatus = data.newMemberDefaultStatus;
    this.deadline = data.deadline;
    this.hasExpired = data.hasExpired;
    this.requestUri = data.requestUri;
    this.validateAddress = data.validateAddress;
    this.isAddressSharedLabel = data.isAddressSharedLabel;
    this.includePaymentPage = data.includePaymentPage;
    this.isArchived = data.isArchived;
    if (data.fields) {
      this.fields = data.fields
        .map((field) => {
          if (field) {
            return ApplicationField.parse(field);
          }
        })
        .sort((a, b) => a.rank - b.rank);
    }
    if (data.pages) {
      this.pages = data.pages
        .map((page) => {
          if (page) {
            return FormPage.parse(page);
          }
        })
        .sort((a, b) => a.pageNumber - b.pageNumber);
    }
    this.canDelete = data.canDelete;
  }
  public update(data: ApplicationDefinition) {
    if (!data) return null;
    this.setData(data);

    this.updateQuestions(data.questions);
    return this;
  }
  public static parse(data: any): ApplicationDefinition {
    if (!data) return null;
    let application = new ApplicationDefinition();
    application.setData(data);
    if (data.questions) {
      application.setQuestions(data.questions);
    }
    return application;
  }

  public mergePageQuestions() {
    let questions = this.pages
      .filter((p) => p.questions.length > 0)
      .map((page) => page.questions)
      .reduce((a, b) => a.concat(b));
    this.setQuestions(questions);
  }
}
